export default "__VITE_ASSET__bc5d7ae9__"